import styled from "styled-components";

export const StyledSection = styled.section`
  background-color: #fff;

  .inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 96px 40px;
  }

  .title {
    font-size: 2.4rem;
    font-weight: 800;
    color: #1E3A8A;
    text-align: center;
    margin-bottom: 64px;
    line-height: 1.2;
  }

  .case-card {
    /* es un <button>: se restablecen los estilos nativos */
    width: 100%;
    font: inherit;
    color: inherit;
    text-align: left;
    background: #fff;
    border: 1px solid #E2E8F0;
    border-radius: 20px;
    padding: 48px 36px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
    box-shadow: 0 2px 12px rgba(26, 86, 219, 0.06);

    &:hover {
      border-color: #1A56DB;
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(26, 86, 219, 0.12);
    }
  }

  .case-card__header {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .case-card__icon-wrapper {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: #EFF6FF;
    border: 1px solid #BFDBFE;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .case-card__icon {
    font-size: 3.2rem !important;
    color: #1A56DB;
  }

  .case-card__number {
    font-size: 1.4rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #1A56DB;
    margin-bottom: 4px;
  }

  .case-card__actor {
    font-size: 2rem;
    font-weight: 700;
    color: #1E3A8A;
    line-height: 1.2;
  }

  .case-card__divider {
    height: 1px;
    background: #E2E8F0;
  }

  .case-card__desc {
    font-size: 1.8rem;
    color: #475569;
    line-height: 1.75;
    margin: 0;
    flex: 1;
  }
`;

export const StyledModal = styled.div`
  .modal-header {
    background: linear-gradient(135deg, #0F172A 0%, #1E3A8A 100%);
    padding: 36px 40px 32px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .modal-header__left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .modal-header__icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    background: rgba(56, 189, 248, 0.15);
    border: 1px solid rgba(56, 189, 248, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .modal-header__icon {
    font-size: 2.8rem !important;
    color: #38BDF8;
  }

  .modal-header__number {
    font-size: 1.4rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #38BDF8;
    margin-bottom: 4px;
  }

  .modal-header__title {
    font-size: 2.8rem;
    font-weight: 800;
    color: #fff;
    line-height: 1.2;
  }

  .close-btn {
    color: rgba(255,255,255,0.6) !important;
    flex-shrink: 0;

    &:hover { color: #fff !important; }
  }

  .modal-body {
    padding: 40px;

    p {
      font-size: 1.8rem;
      color: #475569;
      line-height: 1.8;
      margin-bottom: 20px;

      &:last-child { margin-bottom: 0; }
    }
  }
`;
